// extracted by mini-css-extract-plugin
module.exports = {"editContent":"Container-moduleeditContent210","miniSidebar":"Container-moduleminiSidebarhRZ"};